export interface ThumbnailViewerImage {
  src: string;
  alt?: string;
}

export enum ThumbnailViewerArrowPosition {
  OUTSIDE = 'outside',
  INSIDE = 'inside',
}

export enum ThumbnailViewerSlidesToScroll {
  INDIVIDUAL = 'individual',
  GROUP = 'group',
}
